/**
 * Сверка сделки с номером клиента (`deal.phones` — номера сделки по копии Bitrix, контакт и лид).
 * Сервер не отдаёт сделку другого номера сам (`chat/deal.по_номеру`, `chat/start.открыть`); здесь —
 * вторая линия для ответа, застрявшего в экране: 30.10.26 панель 14 минут показывала чужую сделку.
 * Сверять не с чем (номера не пришли, у чата нет номера) — верим.
 */
export function dealHasPhone(deal: { phones?: string[] } | null | undefined, phones: string[]): boolean {
  if (!deal?.phones?.length || !phones.length) return true;
  return phones.some((p) => deal.phones!.includes(p));
}
